import type {LinkProps} from '@jetbrains/ring-ui/components/link/link'
import * as React from 'react'

import {stringifyId} from '../../../../../../../types'
import type {BuildTypeId, ProjectId} from '../../../../../../../types'
import Link from '../../../../../../common/Link/Link'

import {getHolderProjectLink, getHolderTemplateLink} from './RuleItem.utils'

import styles from './RuleItem.css'

const TIME_TO_BLINK_AFTER_SCROLL = 3000
type ParentLinkProps = LinkProps & {
  href?: never
  projectId?: ProjectId
  buildTypeId?: BuildTypeId
}
export default function ParentLink({projectId, buildTypeId, ...restProps}: ParentLinkProps) {
  const goToParent = React.useCallback(
    (isPlainLeft: boolean, event: React.SyntheticEvent) => {
      const elementToGo = projectId != null ? document.getElementById(stringifyId(projectId)) : null

      if (isPlainLeft && elementToGo != null) {
        event.preventDefault()
        elementToGo.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        elementToGo.classList.add(styles.blink)
        setTimeout(() => elementToGo.classList.remove(styles.blink), TIME_TO_BLINK_AFTER_SCROLL)
      }
    },
    [projectId],
  )
  return (
    <Link
      href={getHolderProjectLink(projectId) ?? getHolderTemplateLink(buildTypeId)}
      onConditionalClick={goToParent}
      {...restProps}
    />
  )
}
